import { api } from './http';

export const changeMyPassword = async (payload: { old_password: string; new_password: string }) => {
  const response = await api.post('/auth/change-password', payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data as { message?: string; error?: string };
};

// Finalize uploaded files (move from temp to destination)
export const finalizeUploadFiles = async (uploadedFiles: string[], folder_path: string, doc_refnum: string) => {

  return api.post('/finalize_upload', {
    uploaded_files: uploadedFiles,
    folder_path: folder_path,
    doc_refnum: doc_refnum,
  },{ headers: { 'Content-Type': 'application/json' } });
};

export const parsePdfFile = async (
  file: File,): Promise<any> => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await api.post('/pdf_form_parse', formData);
      //headers: {
      //  'Content-Type': 'multipart/form-data'
      //}
    //});
    return response.data;
  } catch (error) {
    console.error('File parse failed:', error);
    throw error;
  }
};
